/**
 * Keeps `data-*` attributes flowing to the mobile bottom sheet, since the
 * responsive dropdowns hand the rest of their props to LuxKit rather than
 * spreading them onto both branches.
 */
export function pickDataAttributes(props: Record<string, unknown>): Utils.PropsWithDataAttributes {
  const dataAttributes: Record<string, unknown> = {}

  for (const key of Object.keys(props)) {
    if (key.startsWith('data-')) {
      dataAttributes[key] = props[key]
    }
  }

  return dataAttributes as Utils.PropsWithDataAttributes
}
